// src/components/charts/CreditDebitChart.jsx
import { useMemo } from "react";
import Chart from "react-apexcharts";

const CreditDebitChart = ({ transactionStats, themeColor, textColor }) => {
    const rootStyle = getComputedStyle(document.documentElement);
    const themeColorSecondary = `rgb(${rootStyle
        .getPropertyValue("--theme-color-secondary")
        .trim()})`;
    const { credit, debit, percentage } = useMemo(() => {
        let credit = 0;
        let debit = 0;

        transactionStats.forEach(t => {
            credit += Number(t.total_credit || t.credit || 0);
            debit += Number(t.total_debit || t.debit || 0);
        });

        const total = credit + debit;
        const percentage = total === 0 ? 0 : Math.round((credit / total) * 100);

        return { credit, debit, percentage };
    }, [transactionStats]);

    const options = {
        chart: {
            type: "radialBar",
            sparkline: { enabled: true },
        },
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                hollow: {
                    size: "55%", // ring thickness
                },
                track: {
                    background: "#ECEFF3", // debit track
                    strokeWidth: "100%",
                },
                dataLabels: {
                    value: {
                        show: true,
                        offsetY: -6,
                        fontSize: "32px",
                        fontWeight: 700,
                        color: "#111",
                        formatter: val => `${val}%`,
                    },
                    name: {
                        show: false,
                        text: "Credit Ratio",
                        offsetY: 22,
                        fontSize: "14px",
                        color: themeColor,
                        fontWeight: 500,
                    },
                },
            },
        },
        colors: [themeColor],
        fill: {
            type: "gradient",
            gradient: {
                type: "horizontal",
                gradientToColors: [themeColorSecondary],
                stops: [0, 100],
            },
        },
        stroke: {
            dashArray: 4 // 🔥 segmented bars
        },
    };

    return (
        <div className="text-center">
            <Chart
                options={options}
                series={[percentage]}
                type="radialBar"
            />

            {/* Legend */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                    fontSize: "13px",
                    color: "#6B7280",
                    marginTop: "-6px",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span
                        style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: themeColor,
                        }}
                    />
                    Credit
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span
                        style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: "#ECEFF3",
                        }}
                    />
                    Debit
                </div>
            </div>
        </div>
    );
};

export default CreditDebitChart;
